import ImageGallery from './ImageGallery'; // To be created
import TextHighlightsDisplay from './TextHighlightsDisplay'; // To be created

const DocumentItem = ({
  docFilename,
  docGroup,
  highlights,
  isLoadingHighlights,
  highlightError,
  imageDataUriMap,
  onOpenImageModal
}) => {
  const docDetails = docGroup.details;
  const images = docGroup.images;
  const matchedTerms = docDetails?.matched_terms || [];

  return (
    <div className="document-container">
      <div className="document-result">
        <div className={`document-type-tag document-type-tag-${docDetails?.file_type === 'Nan' || !docDetails?.file_type ? 'other' : docDetails.file_type}`}>
          {docDetails?.file_type === 'Nan' || !docDetails?.file_type ? 'Other' : docDetails.file_type}
        </div>
        <div className="document-details">
          <div className="document-title">{docDetails?.real_name || docFilename}</div>
          {matchedTerms.length > 0 && (
            <div className="matched-terms">
              <span className="matched-terms-label">
                {(images && images.length > 0) ? (
                  // Text if 'images' is true
                  "Matched Word Frequencies (Excluding images): "
                ) : (
                  // Text if 'images' is false
                  "Matched Word Frequencies: "
                )}
              </span>
              {matchedTerms.map(([term, frequency], index) => (
                <span key={term} className="term-frequency">
                  {term}: {frequency}
                  {index < matchedTerms.length - 1 ? " " : ""}
                </span>
              ))}
            </div>
          )}
          {typeof docDetails?.file_link === 'string' && docDetails.file_link !== 'Nan' ? (
            <a href={docDetails.file_link} target="_blank" rel="noopener noreferrer" className="document-link">
              <i className='bx bx-file-blank'></i> View Document
            </a>
          ) : (
            <span>No document link</span>
          )}

          {images && images.length > 0 && (
            <ImageGallery
              images={images}
              docDetails={docDetails}
              docFilename={docFilename}
              imageDataUriMap={imageDataUriMap}
              onOpenImageModal={onOpenImageModal}
            />
          )}
        </div>
      </div>
      <TextHighlightsDisplay
        highlights={highlights}
        isLoading={isLoadingHighlights}
        error={highlightError}
      />
    </div>
  );
};

export default DocumentItem;